import { DataGridFactory as a } from "./index.es639.js";
import { DataGridState as r } from "./index.es640.js";
function c() {
  const t = new a();
  return new r(t);
}
export {
  c as createDataGridState
};
//# sourceMappingURL=index.es597.js.map
